import React, { ForwardRefExoticComponent, MutableRefObject, Ref, useImperativeHandle, useRef } from 'react';

export type ComponentApi<COMPONENT> = COMPONENT extends (props: { ref: Ref<infer API> }) => JSX.Element
  ? API
  : COMPONENT extends ForwardRefExoticComponent<React.RefAttributes<infer API>>
    ? API
    : COMPONENT extends Record<string, any>
      ? COMPONENT
      : {};

interface ComponentApiOutput<COMPONENT = unknown, API = ComponentApi<COMPONENT>> extends MutableRefObject<API | null> {}

/**
 * useImperativeHandle consumer (parent element)
 */
export function useComponentApiConsumer<COMPONENT>(): ComponentApiOutput<COMPONENT> {
  return useRef<ComponentApi<COMPONENT> | null>(null);
}

export const useComponentApiProvider = useImperativeHandle;
